import { render, staticRenderFns } from "./generic-project-master.vue?vue&type=template&id=23ff70e3&scoped=true&"
import script from "./js/generic-project-master.js?vue&type=script&lang=js&"
export * from "./js/generic-project-master.js?vue&type=script&lang=js&"
import style0 from "./generic-project-master.vue?vue&type=style&index=0&id=23ff70e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff70e3",
  null
  
)

export default component.exports